export enum SideViewStates {
  LogoInDesign, NameLogoCreate, TextLogoCreate, SymbolLogoCreate, NumberLogoCreate, Library
}